// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function TbDefs(Props) {
  return React.createElement("defs", undefined, React.createElement("filter", {
                  id: "svg-shadow",
                  height: "200%",
                  width: "200%",
                  x: "0",
                  y: "0"
                }, React.createElement("feOffset", {
                      dx: "1",
                      dy: "1",
                      in: "SourceAlpha",
                      result: "offOut"
                    }), React.createElement("feGaussianBlur", {
                      in: "offOut",
                      result: "blurOut",
                      stdDeviation: "2"
                    }), React.createElement("feBlend", {
                      in: "SourceGraphic",
                      in2: "blurOut",
                      mode: "normal"
                    })), React.createElement("filter", {
                  id: "grayscale"
                }, React.createElement("feColorMatrix", {
                      type: "saturate",
                      values: "0"
                    })), React.createElement("filter", {
                  id: "blurMe"
                }, React.createElement("feGaussianBlur", {
                      in: "SourceGraphic",
                      result: "blur2",
                      stdDeviation: "2"
                    }), React.createElement("feGaussianBlur", {
                      in: "SourceGraphic",
                      result: "blur4",
                      stdDeviation: "4"
                    }), React.createElement("feGaussianBlur", {
                      in: "SourceGraphic",
                      result: "blur8",
                      stdDeviation: "8"
                    }), React.createElement("feMerge", undefined, React.createElement("feMergeNode", {
                          in: "blur2"
                        }), React.createElement("feMergeNode", {
                          in: "blur4"
                        }), React.createElement("feMergeNode", {
                          in: "blur8"
                        }))));
}

var make = React.memo(TbDefs);

export {
  make ,
  
}
/* make Not a pure module */
